import { createSlice } from '@reduxjs/toolkit';
import { fetchFeatureToggles } from './thunks';

const initialState: FeatureToggleState = {
  features: {
    shouldShowIshiOfferDisclaimer: false,
  },
};

const featureToggleSlice = createSlice({
  name: 'join',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    // Here because we're using redux thunk to externalise the action state
    builder.addCase(fetchFeatureToggles.fulfilled, (state, action) => {
      state.features = action.payload;
    });
  },
});

export default featureToggleSlice.reducer;
